module.exports = __webpack_public_path__ + "img/audio-mark4.1e691c0c.png";